import React from 'react'
import { connect } from 'react-redux'
import { Map } from 'immutable'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'
import ProgressBar, { createProgressList } from 'components/ProgressBar'
import { roundTo } from 'helpers/math'
import messages from './translate'

function DailyProgressBar(props) {
  const {
    logbookData,
    intl: { formatMessage },
  } = props
  const {
    events_in_progress,
    events_complete,
    events_count,
  } = logbookData.toJS()
  const percentCompleteValue =
    !events_complete || !events_count
      ? 0
      : roundTo(events_complete / events_count, 3, 1)
  const percentInProgressValue =
    !events_in_progress || !events_count
      ? 0
      : roundTo(events_in_progress / events_count, 3, 1)
  const label = formatMessage(messages.eventsDone, {
    percent: percentCompleteValue,
  })
  const progressList = createProgressList([
    {
      value: percentCompleteValue,
      className: 'pg-complete',
      tooltip: formatMessage(messages.eventsComplete, {
        complete: events_complete,
        total: events_count,
      }),
    },
    {
      value: percentInProgressValue,
      className: 'pg-in-progress',
      tooltip: formatMessage(messages.eventsInProgress, {
        progress: events_in_progress,
        total: events_count - events_complete,
      }),
    },
  ])

  return (
    <div className="pg-paper">
      <ProgressBar label={label} progressList={progressList} />
    </div>
  )
}

ProgressBar.propTypes = {
  logbookData: PropTypes.instanceOf(Map),
}

ProgressBar.defaultProps = {
  logbookData: Map({
    events_in_progress: 0,
    events_complete: 0,
    events_count: 0,
  }),
}

export default connect(state => ({
  logbookData: state.getIn(['logbook', 'dailyEvents']),
}))(injectIntl(DailyProgressBar))
